<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";

export default {
    name: "BreadCrumbSession" ,
    components: {
        AjaxLoad,
    },
    data() {
        return {
            session: null,
        }
    },
    computed: {
        breadcrumb() {
            return {
                text: this.session?.NAME,
            };
        }
    },
    beforeDestroy() {
        this.$store.commit('UPDATE_BREAD_CRUMBS', {session: null});
    },
}
</script>

<template>
    <ajax-load
        v-model="session"
        :active="!!$route.params.ID_SESSION"
        :url="$apiUrl.getForumEventSessionUrl($route.params)"
        :transform="response => response.data.data.items[0]"
        @input="$store.commit('UPDATE_BREAD_CRUMBS', {session: $event})"
    >
        <router-view></router-view>
    </ajax-load>
</template>

<style scoped lang="scss">

</style>